import { gql } from "@apollo/client";

export const GET_VM_PERFORMANCE = gql`
  query GetVmPerformance($vmId: ID!, $startDate: String!, $endDate: String!) {
    getVmPerformance(vmId: $vmId, startDate: $startDate, endDate: $endDate) {
      vmId
      vmName
      vmType
      dailyPerformances {
        date
        maxCpu
        maxCpuTime
        maxUsedRamPercentage
        maxUsedRamTime
      }
    }
  }
`;

export const GET_VM_PERFORMANCE_SUMMARY = gql`
  query GetVmPerformanceSummary($vmId: ID!, $startDate: String!, $endDate: String!) {
    getVmPerformanceSummary(vmId: $vmId, startDate: $startDate, endDate: $endDate) {
      vmId
      vmName
      avgMaxCpu
      avgCpu
      avgMaxRamPercentage
      avgRamPercentage
    }
  }
`;

export const GET_VM_AVAILABLE_RAM = gql`
  query GetVmAvailableRam($vmId: ID!, $startDate: String!, $endDate: String!) {
    getVmAvailableRam(vmId: $vmId, startDate: $startDate, endDate: $endDate) {
      vmId
      vmName
      dailyAvailableRam {
        date
        availableRamPercentage
        timestamp
      }
    }
  }
`;

export const GET_VM_METRIC_TOTAL = gql`
  query GetVmMetricTotal($vmId: ID!, $startDate: String!, $endDate: String!, $metricType: MetricType!) {
    getVmMetricTotal(vmId: $vmId, startDate: $startDate, endDate: $endDate, metricType: $metricType) {
      vmId
      vmName
      metricType
      dailyTotals {
        date
        total
      }
    }
  }
`;